<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    direction?: 'horizontal' | 'vertical'
    size?: 'small' | 'middle' | 'large' | number
    align?: 'start' | 'end' | 'center' | 'baseline'
    wrap?: boolean
    block?: boolean
  }>(),
  {
    direction: 'horizontal',
    size: 'small',
    align: undefined,
    wrap: false,
    block: false
  }
)

const gapSize = computed(() => {
  if (typeof props.size === 'number') return `${props.size}px`
  switch (props.size) {
    case 'small': return '8px'
    case 'middle': return '16px'
    case 'large': return '24px'
    default: return '8px'
  }
})
</script>

<template>
  <div
    class="rr-space"
    :class="[
      `is-${direction}`,
      align ? `is-align-${align}` : '',
      { 'is-wrap': wrap, 'is-block': block }
    ]"
    :style="{ gap: gapSize }"
  >
    <slot />
  </div>
</template>

<style scoped>
.rr-space {
  display: inline-flex;
  box-sizing: border-box;
}

.rr-space.is-horizontal {
  flex-direction: row;
  align-items: center;
}

.rr-space.is-vertical {
  flex-direction: column;
}

.rr-space.is-wrap {
  flex-wrap: wrap;
}

.rr-space.is-block {
  display: flex;
  width: 100%;
}

.rr-space.is-align-start { align-items: flex-start; }
.rr-space.is-align-end { align-items: flex-end; }
.rr-space.is-align-center { align-items: center; }
.rr-space.is-align-baseline { align-items: baseline; }
</style>
